import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewEncapsulation,
} from '@angular/core';
import { PanelsInterfaceComponent } from '../panels-interface.component';

@Component({
  selector: 'project-panel-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsSummaryComponent implements PanelsInterfaceComponent, OnInit {
  @Input() project: any;
  @Input() account: any;
  @Input() panelDef: any;
  @Input() data: any;
  @Input() canEditPanelDef = true;
  @Output() onUpdate: EventEmitter<string> = new EventEmitter();
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   */
  constructor() {}

  ngOnInit() {}
}
